import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SButton } from '@strana-artw/ui-kit';
import { useFormValidator } from '@/shared/composables';
import { useAgentProfileStore } from '@/store/agentProfile';
export default {
  name: 'RestorePassword',
  components: {
    SButton: SButton
  },
  setup: function setup() {
    return _objectSpread({
      agentProfileStore: useAgentProfileStore()
    }, useFormValidator());
  },
  data: function data() {
    return {
      loader: false
    };
  },
  mounted: function mounted() {
    this.form.email = this.agentProfileStore.profile.email;
  },
  methods: {
    backToChangePassword: function backToChangePassword() {
      this.agentProfileStore.setStage('CHANGE_PASSWORD');
    },
    changePassword: function changePassword() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var email, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.v$.$touch();
              if (!_this.v$.$error) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _this.loader = true;
              _context.prev = 2;
              email = _this.form.email;
              _context.next = 3;
              return _this.agentProfileStore.resetPasswordByEmail({
                email: email
              });
            case 3:
              _this.agentProfileStore.setStage('RESTORE_PASSWORD_SUCCESS');
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](2);
              console.error('[RestorePassword/changePassword]: changePassword failed', _t);
              _this.$sentry.captureException(_t);
            case 5:
              _context.prev = 5;
              _this.loader = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 4, 5, 6]]);
      }))();
    }
  }
};